module.exports = __webpack_public_path__ + "img/icon20.40cd1bb9.png";